import Marquee from "react-fast-marquee";
import { Sun } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const MarqueeStrip = () => {
  const { lang, t } = useLanguage();
  return (
    <div className="border-y border-gold/30 bg-[#F4EFE6] py-5" data-testid="marquee-strip">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8">
            <span className={`text-2xl text-maroon/85 sm:text-3xl ${lang === "hi" ? "font-hindi" : "font-display italic"}`}>
              {item}
            </span>
            <Sun size={15} className="text-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
